const DIGITAL_VOUCHER_URL = `${process.env.API_V4_HOST}/digital-vouchers`;

export const getDigitalVoucherTransaction = ($axios, transactionId) => $axios.$get(`${DIGITAL_VOUCHER_URL}/transactions/${transactionId}`);
